import { render } from "./MatchList.vue?vue&type=template&id=7761a3c3&scoped=true"
import script from "./MatchList.vue?vue&type=script&lang=js"
export * from "./MatchList.vue?vue&type=script&lang=js"

import "./MatchList.vue?vue&type=style&index=0&id=7761a3c3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7761a3c3"]])

export default __exports__